import { render } from "./GetZXZQPage.vue?vue&type=template&id=3d1dc301&scoped=true"
import script from "./GetZXZQPage.vue?vue&type=script&lang=js"
export * from "./GetZXZQPage.vue?vue&type=script&lang=js"

import "./GetZXZQPage.vue?vue&type=style&index=0&id=3d1dc301&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1dc301"]])

export default __exports__